<template>
    <div class="table-footer">
        <div class="row">
            <div class="col-md-4">
                <span>Show</span>
                <select class="form-control" v-model="showPerPage" id="resultsPerPage" @change="showPerPageChanged">
                    <option>10</option>
                    <option>25</option>
                    <option>50</option>
                    <option>100</option>
                </select> 
                <span>Entries</span>
            </div>
            <div class="col-md-4 text-center">
                <!-- <span> Selected Ones</span>
                <button class="btn btn-danger" onclick="deleteCampaignGroup();">
                    <svg viewBox="0 0 8 8" class="icon fill-white">
                            <use
                            xlink:href="images/open-iconic.svg#trash"></use>
                        </svg>
                    Delete
                </button> -->
            </div>
            <div class="col-md-4 text-right">
                <a href="javascript:void(0)" v-if="currentPageNumber!=1" @click="getPreviousPageList()">Previous </a>
				<select
					class="form-control selectpicker"
					style = 'max-width:80px;'
					id="brandFilter"
					v-model="currentPageNumber"
					@change="getNewPageList()"
				>
					<option
						v-for="index in totalNoOfPages"
						:key="index"
						:value="index"
					>{{index}}</option>
				</select>
                <a href="javascript:void(0)" v-if="(showPerPage == campaignGroupList.length) && (currentPageNumber!=totalNoOfPages)" @click="getNextPageList()"> Next</a>
				<div style = "padding-right:0px;padding-top:5px">{{getCount()}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CampaignGroupGridFooter',
    data() {
        return {
           totalNoOfPages:1,
        }
    },
	watch:{
		totalCampaignAndProductCount(){
			this.calculateIndexPerPage()
		}
	},
    computed: {
        	totalCampaignAndProductCount:{
			   set(val) {
				   return this.$store.state.totalCampaignAndProductCount = val

			   },
			   get() {
				   return  this.$store.state.totalCampaignAndProductCount
			   }
			},
       showPerPage: {
            set(val) {
                sessionStorage.setItem('campaignGroup:showPerPage',val)
            },
            get() {
                if(sessionStorage.getItem('campaignGroup:showPerPage')){
                    return sessionStorage.getItem('campaignGroup:showPerPage')
                }
                return this.$store.state.showPerPage
            }
        },
        currentPageNumber: {
            set(val) {
                this.$store.state.campaign.actionSelectioncampaignGroupControl = false
      			this.$store.state.campaign.campaignGroupSelectedList = []
                this.$store.state.currentPageNumber = val
            },
            get() {
                return this.$store.state.currentPageNumber
            }
        },
        campaignGroupList() {
            return this.$store.state.campaign.campaignGroupList
        },
    },
    	mounted() {
			this.calculateIndexPerPage()
		},
    methods: {
        	calculateIndexPerPage(){
               this.totalNoOfPages=Math.ceil(this.totalCampaignAndProductCount/this.showPerPage)
			},
        getPreviousPageList() {
            if (this.currentPageNumber <= 1) {
                return
            }
            else {
                this.currentPageNumber -= 1
                this.$store.dispatch('campaign/getCampaignGroupList');
            }
        },
        getNextPageList() {
            this.currentPageNumber += 1
            this.$store.dispatch('campaign/getCampaignGroupList');
        },
		getNewPageList(){
			this.$store.dispatch('campaign/getCampaignGroupList');
		},
		getCount(){
			let pageCount = this.showPerPage * (this.currentPageNumber - 1);
			let extendedcount = parseInt(pageCount)+ parseInt(this.campaignGroupList.length);
            //return	pageCount+1 + ' to ' + extendedcount;
            return	'Showing ' + (pageCount+1) + ' to ' + extendedcount + ' results of ' + this.totalCampaignAndProductCount;
		},
        showPerPageChanged() {
			this.currentPageNumber = 1;
            this.$store.dispatch('campaign/getCampaignGroupList');
        }
    }
}
</script>

<style lang="scss">

</style>
